import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { ShopHeadSection } from '../sections/shop-head-section'
import { PageOuter } from '../components/page-outer'
import { ShopContentSection } from '../sections/shop-content-section'
import { DinersSection } from '../sections/diners-section'
import { TopFurusatoSection } from '../sections/top-furusato-section'
import { TopQuestionnaireSection } from '../sections/top-questionnaire-section'
import { TopShopListSection } from '../sections/top-shop-list-section'
import { pageMaxWidth } from '../styles/page-max-width'
import { ShopGallerySection } from '../sections/shop-gallery-section'

const Inner = styled.div`
  ${pageMaxWidth}
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Inner2 = styled.div`
  max-width: 48.875rem;
  width: 100%;
  padding-bottom: 10rem;
  padding-top: 3.75rem;
  @media (max-width: 40rem){
    padding-bottom: 7.5rem;
    padding-top: 2rem;
  }
`

type ShopPageProps = {

}
export const ShopPage: FunctionComponent<ShopPageProps> = () => {
  return <PageOuter>
    <Inner>
      <Inner2>
        <ShopHeadSection />
        <ShopGallerySection />
        <ShopContentSection />
      </Inner2>
    </Inner>
    <TopShopListSection />
    <TopQuestionnaireSection />
    <DinersSection />
  </PageOuter>
}
